import styled from "styled-components";
import { SpinBenefit } from "./shared/SpinBenefit";

interface WrapperSpinWheelProps {
    clicks: () => void;
}

export const WrapperSpinWheel = ({ clicks }: WrapperSpinWheelProps) => {
    return (
        <StyledWrapperSpinWheel>
            <div className="title">Claim additional benefits</div>
            <StyledContentSpinWeel>
                <SpinBenefit
                    title="Complete Birthday Profile"
                    imgmission="../../images/img-spinbenefit-01.svg"
                    point={20}
                    ticket={1}
                    active={true}
                    onClick={clicks}
                />
                <SpinBenefit
                    title="Redeem point for ticket"
                    imgmission="../../images/img-spinbenefit-01.svg"
                    point={5}
                    ticket={1}
                    onClick={clicks}
                />
            </StyledContentSpinWeel>
        </StyledWrapperSpinWheel>
    );
};

const StyledWrapperSpinWheel = styled.div`
    display: block;
    padding: 0 16px;
    position: relative;
    z-index: 2;
    .title {
        text-align: center;
        color: #fff;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 12px;
        font-weight: 600;
    }
`;

const StyledContentSpinWeel = styled.div`
    background-color: #fff;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    padding: 16px;
`;
